import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { S3PresignedUrlData } from 'types/s3Upload';

export interface IQueryKey {
    queryKey: readonly unknown[] | any[]
}

export interface IUploadUrlData {
    url: S3PresignedUrlData;
    fileName: string;
}

interface IPostParamsData {
    file_name: string;
    feature: string;
    public_read: boolean;
    organization_correlation_id: string;
}

const getUploadUrls = async ({
    queryKey,
}: IQueryKey): Promise<IUploadUrlData> => {
    const params = queryKey[1] as IPostParamsData;
    const response = await axiosInstance.get(API_ENDPOINTS.FILE_STORAGE, { params });
    return response.data;
};

export default getUploadUrls;
